import { Box, ColorOptions, convertHexToRGBA, ModalDialogNew, ModBox, Spacer, Text } from '@jfs/ui-new'
import { Dimensions, ViewStyle } from 'react-native'
import { LinearGradientContainer } from '../../comps/LinearGradient'
import { SvgImage } from '../../comps/SvgImage'
import { getString } from '../../util/languageStrings'
import { Colors } from '../../util/util'

export const chatbotAwarenessData = {
  list1: 'Faster and efficient guided query resolution.',
  list2: 'Learn more about products and services offered by JioPay.',
  list3: 'Track status of your raised quieries.',
  list4: 'Multilingual support.',
}

const btnWidth = 150
export const ChatbotAwareness = ({ show, onPress, onCancel }: any) => {
  // TODO: support get height from for mobile and web
  const height = Math.round(Dimensions.get('screen').height)

  if (!show) {
    return null
  }

  const renderView = () => {
    return (
      <Box height={height - 90} width="100%" position={'relative'}>
        <Box height={height - 100} justify="center">
          <Box zIndex={11}>
            <LinearGradientContainer
              customStyle={
                {
                  borderTopLeftRadius: 25,
                  borderTopRightRadius: 25,
                  overflow: 'hidden',
                } as ViewStyle
              }
              angle={106}
              useAngle={true}
              colorArray={['#f7e8d1', '#fefdfb']}
              direction="HORIZONTAL">
              <Box>
                <Box pr={24} pt={24} alignSelf={'flex-end'} onPress={() => onCancel()} underlayColor={'TRANSPARENT'}>
                  <SvgImage imageName="Close" />
                </Box>
                <Box alignItems={'center'} pv={35}>
                  <SvgImage imageName={'ChatbotAwareness'} />
                </Box>
              </Box>
            </LinearGradientContainer>
            <ModBox
              show={true}
              bg={'WHITE'}
              ph={24}
              pv={32}
              borderBottomLeftRadius={25}
              borderBottomRightRadius={25}
              overflow="hidden">
              <Box align="flex-start">
                <LinearGradientContainer
                  customStyle={
                    {
                      borderRadius: 4,
                      overflow: 'hidden',
                      paddingHorizontal: 4,
                      paddingVertical: 4,
                    } as ViewStyle
                  }
                  angle={90}
                  useAngle={true}
                  colorArray={['#DF9F39', '#966D2E']}
                  direction="HORIZONTAL">
                  <Text fontFamily={'JioType-Bold'} fontSize={12} lineHeight={18} color="WHITE">
                    {getString(null, 'INTRODUCING')}
                  </Text>
                </LinearGradientContainer>
              </Box>
              <Spacer size={12} direction="vertical" />
              <Text fontFamily={'JioType-Black'} fontSize={24} lineHeight={28} color="BLACK_21">
                {getString(null, 'jioPayChatAssistant')}
              </Text>
              <Spacer size={24} direction="vertical" />
              <Box>
                {Object.keys(chatbotAwarenessData)?.map((i, key) => (
                  <Box key={`item-${key}`} flexDirection={'row'} pb={16}>
                    <Box>
                      <SvgImage imageName="SuccessIconTickSmall" />
                    </Box>
                    <Spacer size={12} direction="horizontal" />
                    <Box f={1}>
                      <Text fontFamily={'JioType-Medium'} fontSize={12} lineHeight={16} color="BLACK_21">
                        {chatbotAwarenessData[i]}
                      </Text>
                    </Box>
                  </Box>
                ))}
              </Box>
            </ModBox>
            <Box align={'flex-end'} paddingRight={btnWidth / 2 - 11}>
              <SvgImage imageName="CaretIcon" />
            </Box>
          </Box>
        </Box>
        <Box
          position={'absolute'}
          right={btnWidth / 2}
          borderRightWidth={1}
          borderStyle="dashed"
          width={1}
          height={'80%'}
          bottom={20}
          borderColor="WHITE"
          zIndex={1}
        />
        <Box
          justify="flex-end"
          alignSelf={'flex-end'}
          padding={2}
          borderRadius={45}
          borderWidth={1}
          zIndex={11}
          position="absolute"
          bottom={0}
          borderColor={convertHexToRGBA('#fff', 30) as ColorOptions}>
          <Box
            justify="flex-end"
            alignSelf={'flex-end'}
            padding={2}
            borderRadius={45}
            borderWidth={1}
            borderColor={convertHexToRGBA('#fff', 60) as ColorOptions}>
            <ModBox
              show={true}
              borderRadius={45}
              width={btnWidth}
              bg={Colors.PRIMARY}
              justify="center"
              underlayColor={'SECONDARY' as ColorOptions}
              onPress={onPress}
              overflow={'hidden'}
              align="center">
              <Box flexDirection={'row'} justify="center" align="center" ph={16} pv={12}>
                <Box justify="center" align="center">
                  <SvgImage imageName="ChatIcon" />
                </Box>
                <Spacer size={5} direction="horizontal" />
                <Box>
                  <ModBox justify="center" align="center">
                    <Text fontFamily={'JioType-Bold'} numberOfLines={1} fontSize={14} color="WHITE">
                      {getString(null, 'chatWithUs')}
                    </Text>
                  </ModBox>
                </Box>
              </Box>
            </ModBox>
          </Box>
        </Box>
      </Box>
    )
  }
  return <ModalDialogNew children={renderView()} show={true} type={'centered'} backgroundColor={'TRANSPARENT'} />
}
